import styled from 'styled-components'

interface ImageProps {
    imgMobile: string
    imgDesktop: string
}

interface ModalProps {
    open: boolean
    heightModal: number | null
}

export const StyledModal = styled.div<ModalProps>`
    & > div > div > div > span {
        top: 1em;
    }
    height: ${props => (props.open ? `${props.heightModal}px` : 'auto')};
    & > div > div > div,
    & > div > div {
        height: ${props => (props.open ? '100%' : 'auto')};
    }
    & > div > div > div {
        padding-top: 0;
        background-color: #fbfaf8;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        height: auto;

        & > div > div > div,
        & > div > div {
            width: 700px;
            height: auto;
        }
    }
`

export const StyledImage = styled.div<ImageProps>`
    background-image: url(${({ imgMobile }) => imgMobile});
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        background-image: url(${({ imgDesktop }) => imgDesktop});
        background-position: center top;
        background-repeat: no-repeat;
        width: 700px;
        height: 432px;
    }
`

export const LoadingContainer = styled.div`
    display: flex;
    height: 100dvh;
    justify-content: center;
    align-items: center;
`
